// Projects API services
import { apiClient } from '@/services/api';
import type {
  Project,
  ProjectCreation,
  Site,
  SiteCreation,
  SiteChanges,
  UpdateDataProject,
} from '../types';
import type { ApiResult } from '@/types';

export const projectsApi = {
  // Get all projects
  getProjects: (): Promise<ApiResult<{ data: Project[] }>> => {
    return apiClient.get<{ data: Project[] }, undefined>('/api/projects');
  },

  // Get single project by ID
  getProject: (projectId: number): Promise<ApiResult<{ data: Project }>> => {
    return apiClient.get<{ data: Project }, undefined>(
      `/api/projects/${projectId}`
    );
  },

  // Create new project
  createProject: (
    projectData: ProjectCreation
  ): Promise<ApiResult<{ id: number }>> => {
    return apiClient.post<ProjectCreation, { id: number }>(
      '/api/projects',
      projectData
    );
  },

  // Update project
  updateProject: (
    updateData: UpdateDataProject
  ): Promise<ApiResult<Project>> => {
    return apiClient.put<UpdateDataProject, Project>(
      `/api/projects/${updateData.id}`,
      updateData
    );
  },

  // Delete project
  deleteProject: (
    projectId: number
  ): Promise<ApiResult<{ success: boolean }>> => {
    return apiClient.delete<{ success: boolean }, undefined>(
      `/api/projects/${projectId}`
    );
  },

  // Get sites for a project
  getSites: (projectId?: number): Promise<ApiResult<Site[]>> => {
    const url = projectId ? `/api/sites?projectId=${projectId}` : '/api/sites';
    return apiClient.get<Site[], { projectId?: number }>(
      url,
      projectId ? { projectId } : undefined
    );
  },

  // Create new site
  createSite: (siteData: SiteCreation): Promise<ApiResult<Site>> => {
    return apiClient.post<SiteCreation, Site>('/api/sites', siteData);
  },

  // Update site
  updateSite: (
    siteId: number,
    changes: SiteChanges
  ): Promise<ApiResult<Site>> => {
    return apiClient.put<{ id: number } & SiteChanges, Site>(
      `/api/sites/${siteId}`,
      {
        id: siteId,
        ...changes,
      }
    );
  },
};

export * from '../types';
